import { render, staticRenderFns } from "./TravellerDetail.vue?vue&type=template&id=11e30ad2&scoped=true&"
import script from "./TravellerDetail.vue?vue&type=script&lang=js&"
export * from "./TravellerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e30ad2",
  null
  
)

export default component.exports